import React from 'react';
import { CONTACTS } from '@department-of-veterans-affairs/component-library/contacts';
import environment from 'platform/utilities/environment';

const PersonalInformationNote = () => (
  <div className="vads-u-margin-bottom--4" data-testid="default-note">
    <p>
      <strong>Note:</strong> To protect your personal information, we don’t
      allow online changes to your name, date of birth, or Social Security
      number. If you need to change this information, call us at{' '}
      <va-telephone contact={CONTACTS.GI_BILL} /> (
      <va-telephone contact="711" tty />
      ). We’re here Monday through Friday, between 8:00 a.m. and 9:00 p.m. ET.
    </p>
    <va-link
      external
      href={`${environment.BASE_URL}/resources/how-to-change-your-legal-name-on-file-with-va/`}
      text="Find more detailed instructions for how to change your legal name"
    />
  </div>
);

export default PersonalInformationNote;
